import React, { useState } from 'react'
import { FaWhatsapp, FaEnvelope } from 'react-icons/fa'
import { useSearchStore } from '../store/searchStore'
import { useAuthStore } from '../store/authStore'
import { buildWhatsAppURL } from '../config/whatsapp'
import ContactModal from './ContactModal'

function FABButton({ onClick, href, ariaLabel, tooltip, bgColor, icon, external }) {
  const [hovered, setHovered] = useState(false)

  const commonProps = {
    'aria-label': ariaLabel,
    onMouseEnter: () => setHovered(true),
    onMouseLeave: () => setHovered(false),
    className: 'flex items-center justify-center w-8 h-8 md:w-14 md:h-14 rounded-full shadow-lg transition-transform duration-150 hover:scale-110 select-none',
    style: { backgroundColor: bgColor, WebkitTouchCallout: 'none' },
    onContextMenu: e => e.preventDefault(),
  }

  return (
    <div className="flex items-center gap-3 justify-end">
      {hovered && (
        <span className="bg-gray-800 text-white text-sm px-3 py-1.5 rounded-lg shadow-lg whitespace-nowrap border border-gray-600">
          {tooltip}
        </span>
      )}
      {onClick ? (
        <button onClick={onClick} {...commonProps}>{icon}</button>
      ) : (
        <a href={href} {...(external ? { target: '_blank', rel: 'noopener noreferrer' } : {})} {...commonProps}>
          {icon}
        </a>
      )}
    </div>
  )
}

function WhatsAppFAB() {
  const { results, searchedDimensions } = useSearchStore()
  const { user } = useAuthStore()
  const [showContactModal, setShowContactModal] = useState(false)

  const bestFit = results.length > 0
    ? results.reduce((best, r) =>
        r.volumeRatio != null && (best === null || r.volumeRatio < best.volumeRatio) ? r : best
      , null)
    : null

  const waTooltip = bestFit ? `Ask about the ${bestFit.model} on WhatsApp` : 'Chat with us on WhatsApp'

  return (
    <>
      {showContactModal && <ContactModal onClose={() => setShowContactModal(false)} />}
      <div className="fixed bottom-6 right-6 z-50 flex flex-col gap-3">
        <FABButton
          onClick={() => setShowContactModal(true)}
          ariaLabel="Contact us"
          tooltip="Contact us"
          bgColor="#4B5563"
          icon={<FaEnvelope className="w-4 h-4 md:w-[26px] md:h-[26px]" color="white" />}
        />
        <FABButton
          href={buildWhatsAppURL(bestFit, searchedDimensions, user)}
          ariaLabel="Chat with us on WhatsApp"
          tooltip={waTooltip}
          bgColor="#25D366"
          icon={<FaWhatsapp className="w-[18px] h-[18px] md:w-[30px] md:h-[30px]" color="white" />}
          external={true}
        />
      </div>
    </>
  )
}

export default WhatsAppFAB
